import axios from 'axios';
import { ROOT_URL } from "../Actions/types";

const instance = axios.create({ baseURL: ROOT_URL });
instance.defaults.timeout = 600000;

export default instance;



// WEBPACK FOOTER //
// ./src/Api/RahApi.js